import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { selectActiveProjects, selectBasemap } from "../../reducers";
import PropTypes from "prop-types";
import { getIcon } from "../../modules/hub";
import { setActiveProject } from "../../actions/ui";

import { StaticMap, Marker } from "react-map-gl";
import styles from "./popup.module.scss";
import streetsMapStyle from "../map/streets-map-style.json";
import satteliteMapStyle from "../map/streets-map-style.json";

const Popup = props => {
    const { activeProjects, setActiveProject, basemap } = props;
    const [viewingProjectIndex, setViewingProjectIndex] = useState(0);
    useEffect(() => {
        setViewingProjectIndex(0);
    }, [activeProjects]);
    const viewingProject = activeProjects[viewingProjectIndex];
    if (!viewingProject) return null;
    const getBaseMap = () => {
        return basemap === "ROADMAP" ? streetsMapStyle : satteliteMapStyle;
    };

    return (
        <div onClick={() => setActiveProject(null)} className={styles.overlay}>
            <div
                onClick={e => e.stopPropagation()}
                className={styles.projectPopup}
            >
                <p
                    className={styles.multipleHubText}
                    style={{
                        opacity: activeProjects.length > 1 ? 1 : 0,
                    }}
                >
                    There are {activeProjects.length} innovation initiatives at
                    this address.
                </p>
                <div className={styles.iconAndNameRow}>
                    {activeProjects.length > 1 && (
                        <img
                            className={styles.chevronIcon}
                            src={"/img/chevron-left-solid.svg"}
                            alt={"right arrow"}
                            role="button"
                            disabled={viewingProjectIndex === 0}
                            data-disabled={viewingProjectIndex === 0}
                            onClick={e => {
                                setViewingProjectIndex(x => x - 1);
                            }}
                        />
                    )}
                    <div className={styles.iconAndName}>
                        <img
                            className={styles.markerIcon}
                            src={getIcon(viewingProject.hubName)}
                            alt={`Marker icon for: ${viewingProject.hubName}`}
                        />{" "}
                        <h3>{viewingProject.hubName}</h3>
                    </div>
                    {activeProjects.length > 1 && (
                        <img
                            className={styles.chevronIcon}
                            src={"/img/chevron-right-solid.svg"}
                            alt={"right arrow"}
                            role="button"
                            disabled={
                                viewingProjectIndex ===
                                activeProjects.length - 1
                            }
                            data-disabled={
                                viewingProjectIndex ===
                                activeProjects.length - 1
                            }
                            onClick={e => {
                                if (
                                    viewingProjectIndex ===
                                    activeProjects.length - 1
                                ) {
                                    return;
                                }
                                setViewingProjectIndex(x => x + 1);
                            }}
                        />
                    )}
                </div>
                <button
                    autoFocus
                    className={styles.closeButton}
                    onClick={() => setActiveProject(null)}
                >
                    <img src="/img/cross.svg" alt="Cross" />
                </button>
                <h4>{viewingProject["Name"]}</h4>
                <p>
                    <label>Focus:</label>
                    <span> {viewingProject["Focus"]}</span>
                </p>

                {viewingProject["Website"] && (
                    <p>
                        <a target="_blank" href={viewingProject["Website"]}>
                            Website
                        </a>
                    </p>
                )}
                {viewingProject["Community link"] && (
                    <p>
                        <a
                            target="_blank"
                            href={viewingProject["Community link"]}
                        >
                            Community link
                        </a>
                    </p>
                )}
                {viewingProject["Address"] && (
                    <p>
                        <label>Address:</label>
                        <span>{viewingProject["Address"]}</span>
                    </p>
                )}
                <StaticMap
                    mapboxApiAccessToken={
                        process.env.REACT_APP_MAPBOX_API_TOKEN
                    }
                    width={"100%"}
                    height={200}
                    zoom={10}
                    mapStyle={getBaseMap()}
                    longitude={parseFloat(viewingProject.Longitude)}
                    latitude={parseFloat(viewingProject.Latitude)}
                >
                    <Marker
                        latitude={parseFloat(viewingProject.Latitude)}
                        longitude={parseFloat(viewingProject.Longitude)}
                    >
                        <img
                            style={{
                                transform: `translate(-50%, -100%)`,
                            }}
                            alt="pin"
                            src={"/img/black-pin.svg"}
                        />
                    </Marker>
                </StaticMap>
            </div>
        </div>
    );
};

const mapStateToProps = s => ({
    activeProjects: selectActiveProjects(s),
    basemap: selectBasemap(s),
});
const mapDispatchToProps = {
    setActiveProject,
};
Popup.propTypes = {
    setActiveProject: PropTypes.func.isRequired,
    activeProjects: PropTypes.array.isRequired,
    basemap: PropTypes.string.isRequired,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Popup);



// WEBPACK FOOTER //
// ./src/components/popup/popup.js